var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import PrimarySidebarLayout from "../../Layout/PrimarySidebarLayout";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import CampaignPrimarySidebar from "../../Container/Campaign/CampaignPrimarySidebar";
import FAIcon from "../../UI/FAIcon/FAIcon";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import LinkToPerson from "../../Presentational/Person/LinkToPerson/LinkToPerson";
import DateService from "../../../Services/Shared/Date.service";
import NumberService from "../../../Services/Shared/Number.service";
import CampaignService from "../../../Services/Campaign.service";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import { getCampaignDetailPath, getCampaignNewPath } from "./CampaignRoutes";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import CampaignTypeService from "../../../Services/CampaignType.service";
import PageTitle from "../../UI/PageTitle/PageTitle";
import CampaignStatusBadge from "../../Presentational/CampaignStatus/CampaignStatusBadge";
const PAGE_SIZE = 20;
const CampaignList = (props) => {
    const virtualizedApp = useVirtualizedApp();
    const QUERY_DEFAULT = "";
    const CAMPAIGN_TYPE_IDS_DEFAULT = null;
    const DEFAULT_SEARCH = {
        query: QUERY_DEFAULT,
        campaignTypeIds: CAMPAIGN_TYPE_IDS_DEFAULT,
    };
    const [query, setQuery] = React.useState(QUERY_DEFAULT);
    const [campaignTypes, setCampaignTypes] = React.useState(CAMPAIGN_TYPE_IDS_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const runSearch = () => {
        setSearchArgs({
            query,
            campaignTypeIds: campaignTypes === null || campaignTypes === void 0 ? void 0 : campaignTypes.map((ct) => ct.id),
        });
    };
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No emails",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => CampaignService.search({
            query: sArgs.query,
            campaignTypeIds: sArgs.campaignTypeIds,
            virtualizedAppName: virtualizedApp.name,
        }, {
            max: PAGE_SIZE,
            offset: pageNumber * PAGE_SIZE,
            sort: sort === null || sort === void 0 ? void 0 : sort.sort,
            order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
        }),
        initialSort: { sort: "CAMPAIGN_CREATED_DATE", order: "desc" },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                size: 2,
                sortId: "CAMPAIGN_NAME",
            },
            { title: "Type", sortId: "CAMPAIGN_TYPE_NAME" },
            { title: "Created By", sortId: "CAMPAIGN_CREATED_BY" },
            {
                title: "Created",
                sortId: "CAMPAIGN_CREATED_DATE",
            },
            {
                title: "Status Date",
            },
            { title: "Messaging Status", sortId: "CAMPAIGN_STATUS" },
            {
                title: "Filter",
                sortId: "CAMPAIGN_FILTER_NAME",
                showAt: "xl",
            },
            {
                title: "Sent",
                align: "end",
                sortId: "CAMPAIGN_SENT_COUNT",
            },
            {
                title: "Delivered Rate",
                align: "end",
                sortId: "CAMPAIGN_DELIVERED_RATE",
                showAt: "xl",
            },
            {
                title: "Open Rate",
                align: "end",
                sortId: "CAMPAIGN_OPEN_RATE",
            },
            {
                title: "Bounce Rate",
                align: "end",
                sortId: "CAMPAIGN_BOUNCE_RATE",
                showAt: "xl",
            },
            {
                title: _jsx("span", { title: "Click Through Rate", children: "CTR" }),
                align: "end",
                sortId: "CAMPAIGN_CLICK_THROUGH_RATE",
            },
        ],
        rows: (results) => results.data.map((campaign) => {
            var _a, _b, _c, _d, _e;
            return [
                _jsx(Link, { to: getCampaignDetailPath({ id: campaign.id }), children: campaign.name }, 0),
                campaign.campaignTypeName,
                _jsx(LinkToPerson, { affiliationId: campaign.createdBy.affiliationId, virtualizedApp: virtualizedApp.name, children: campaign.createdBy.fullName }, 1),
                DateService.displayLong(new Date(campaign.createdDate)),
                campaign.lastStatusDate
                    ? DateService.displayLong(new Date(campaign.lastStatusDate))
                    : null,
                _jsx(CampaignStatusBadge, { status: campaign.campaignStatus }),
                campaign.population.name,
                ((_a = campaign.metrics) === null || _a === void 0 ? void 0 : _a.sentCount) || 0,
                NumberService.asPercentage(((_b = campaign.metrics) === null || _b === void 0 ? void 0 : _b.deliveredRate) || 0) +
                    "%",
                NumberService.asPercentage(((_c = campaign.metrics) === null || _c === void 0 ? void 0 : _c.openRate) || 0) + "%",
                NumberService.asPercentage(((_d = campaign.metrics) === null || _d === void 0 ? void 0 : _d.bounceRate) || 0) + "%",
                NumberService.asPercentage(((_e = campaign.metrics) === null || _e === void 0 ? void 0 : _e.clickThroughRate) || 0) +
                    "%",
            ];
        }),
    });
    return (_jsx(PrimarySidebarLayout, { sidebar: (setIsOpen) => (_jsx(CampaignPrimarySidebar, { emailsOpen: true, setIsOpen: setIsOpen })), sidebarSize: "sm", children: () => {
            var _a;
            return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex w-100", children: _jsxs(Link, { className: "btn btn-link", to: getCampaignNewPath({}), children: [_jsx(FAIcon, { className: "mr-2", icon: "plus", type: "fal" }), _jsx("span", { className: "d-none d-lg-inline-block", children: "New" })] }) }), children: _jsxs("div", { className: "container-fluid pt-3 pb-5 fullMinHeightMinusSecondaryNav bg-light", children: [_jsxs(PageTitle, { children: ["Emails", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) == null ? "" : `(${dataState.data.total})`] }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsx("div", { className: "form-group mr-3 mt-2", children: _jsxs("div", { className: "input-group", children: [_jsx("input", { className: "form-control", type: "text", placeholder: "Search", value: query, onKeyPress: (e) => {
                                                    if (e.key === "Enter") {
                                                        runSearch();
                                                    }
                                                }, onChange: (e) => setQuery(e.target.value) }), _jsx("div", { className: "input-group-append input-group-append-blend", children: _jsx("button", { className: "btn btn-outline-secondary", onClick: () => runSearch(), children: _jsx(FAIcon, { icon: "search" }) }) })] }) }), _jsx("div", { className: "form-group mt-2 mr-3", children: _jsx(DeprecatedSelect.Async, { loadOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
                                            const { data } = yield CampaignTypeService.search({
                                                query: search,
                                            });
                                            return {
                                                options: data,
                                            };
                                        }), style: { width: 300 }, multi: true, value: campaignTypes, onChange: setCampaignTypes, placeholder: "Type", "aria-label": "Campaign Type", valueKey: "id", labelKey: "name" }) }), _jsx("div", { className: "mt-2", children: _jsx("button", { className: "btn btn-primary", onClick: () => runSearch(), children: "Search" }) })] }), table] }) }));
        } }));
};
export default withRouter(CampaignList);
